<template>
  <div style="width: 100%; height: 100%; position: absolute; color: white">
    <div class="manhour_item top">
      Total Manhour: {{ total_manhour.toLocaleString() }}
    </div>
    <div class="manhour_item mid">
      <div class="inner under">
        {{ recordable_accident.toLocaleString() }}
      </div>
      <div class="inner no_under">
        &nbsp;Days w/o a Recordable Accident
      </div>
    </div>

    <div class="manhour_item bottom">
      <div class="inner under">
        {{ lost_time_injury.toLocaleString() }}
      </div>
      <div class="inner no_under">
        &nbsp;Days w/o a Lost Time Injury
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'

export default {
  props: ['project_id', 'total_manhour'],
  name: "total_manhour",
  data() {
    return {
      my_project_id: this.project_id,
      recordable_accident: '-',
      lost_time_injury: '-'
    }
  },
  mounted() {
    var that = this
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    let postData = {
      cms_conid: window.localStorage.getItem('cons_id'),
      proj_id: this.my_project_id,
      user: window.localStorage.getItem("token_key"),
      token: window.localStorage.getItem('token')
    }
    axios.post(this.$store.getters.getCmsServer + "DBProjInfo", postData).then(resp => {
      var errNo = resp.data.errno
      var errStr = resp.data.errstr_cn
      if (errNo == "0") {
        var result = resp.data.result[0]
        var commencement = result.construction_start
        if (commencement) {
          let dateBegin = new Date(commencement)
          let dateEnd = new Date();//获取当前时间
          let dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
          let dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000));//计算出相差天数
          that.recordable_accident = dayDiff
          that.lost_time_injury = dayDiff
        }
      }
    })
  }
}
</script>

<style scoped>

.manhour_item {
  width: 90%;
  left: 5%;
  height: 25%;
  position: absolute;
  top: 5%;
  text-align: center;
  color: white;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.top {
  font-size: 80px;
}

.mid {
  font-size: 60px;
  height: 20%;
  top: 40%;
}

.inner {
  display: inline;
}

.under {
  /*text-decoration: underline;*/
  text-align: center;
  border-bottom: 5px solid white;
}

.no_under {
  width: 16px;
  margin-left: -16px;
  background-color: #31334a;
  border-bottom: 5px solid #31334a;
}

.bottom {
  font-size: 60px;
  height: 20%;
  top: 75%;
}
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/total_manhour.vue